<i18n>
en:
  title: "Reserve"
ja:
  title: "予約"
</i18n>

<template lang="pug">
  div
    //- タイトル
    v-img(src="@/assets/images/header-back-reserve.png" min-height="180px")
      v-row.fill-height(align="center")
        v-col(align="center")
          h1.white--text|{{$t('title')}}

    //- エラーメッセージ
    template(v-if="errMsg")
      v-container
        v-row
          v-col(cols="12" align="center")
            v-alert.d-inline-block(dense outlined type="error")
              div(v-html="errMsg")

    //- サブビュー
    template(v-else)
      router-view(v-bind:shop="shop")
</template>

<script>
export default {
  data () {
    return {
      // 店舗
      shop: null,
      // エラーメッセージ
      errMsg: null
    }
  },
  created () {
    this.loadShop()
  },
  watch: {
    /**
     * 言語
     */
    '$store.state.apps.language' () {
      this.loadShop()
    }
  },
  methods: {
    /**
     * 店舗を読込
     */
    loadShop () {
      const shopId = this.utils.cast.int(this.$route.params.id)
      if (!shopId) {
        this.shop = {}
        this.errMsg = this.$t('error.SYSERR')
        return
      }

      this.shop = null

      this.api.shop({
        shopId
      })
        .then(response => {
          this.shop = response.data
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
    }
  }
}
</script>

<style lang="sass" scoped>
h1
  font-size: 48px
  text-shadow: 0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2,0 0 1px #1976d2
  word-break: keep-all
</style>
